import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-programming',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './programming.component.html',
  styleUrls: ['./programming.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgrammingComponent {}
